@if (!isLoginRoute()) {
  <app-header
    #headerRef
    (toggleSidebar)="toggleSidebar()"
    (toggleOverlay)="onOverlayToggle($event)"
    (setLoading)="onSetLoading($event)"
    (eventFilterError)="onHeaderEventErrorFilter($event)"
    (resetFilterError)="resetErrorFilter()"
  ></app-header>
}

@if (isOverlayVisible) {
  <div
    class="search-overlay"
    (click)="onOverlayToggle(false)"
    >
    @if (isLoading) {
      <c-spinner color="light"></c-spinner>
    }
  </div>
}


<!-- <div class="sidebar-overlay" *ngIf="toggleSideBar" (click)="closeSidebar()"> -->
<!-- <app-menuSidebar (toggleSidebar)="toggleSidebar()" (click)="$event.stopPropagation()"></app-menuSidebar> -->
<!-- </div> -->

<router-outlet></router-outlet>

